import { useEffect, useState } from "react";

export const TopTilesTester: React.FC = () => {
    const [baseUrl, setBaseUrl] = useState<string>("https://www.sg.ch");
    const [maxItemsPerCluster, setMaxItemsPerCluster] = useState<number>(1);
    const [nofTiles, setNofTiles] = useState<number>(6);
    const [viewMode, setViewMode] = useState<'tile' | 'list'>('tile');
    const [topTiles, setTopTiles] = useState<any>(null);
    const [showInfoOverlay, setShowInfoOverlay] = useState<'results' | 'cluster' | null>(null);
    
    useEffect(() => {
        // Load Font Awesome
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
        document.head.appendChild(link);
        
        return () => {
            document.head.removeChild(link);
        };
    }, []);
    
    useEffect(() => {
        const asyncFunc = async () => {
            const response = await fetch(`/api/TopTiles?baseUrl=${encodeURIComponent(baseUrl)}&max_nof_items_per_cluster=${maxItemsPerCluster}&nof_tiles=${nofTiles}`, {
                method: 'get',
                headers: { 'Content-Type': 'application/json' }
            })
            const answer = await (response.ok ? response.json() : response.text());
            console.log("answer", answer);
            return answer.value;
        }
        asyncFunc().then(result => {
            setTopTiles(result);
        }).catch(err => {
            console.error(err);
        });
    }, [baseUrl, maxItemsPerCluster, nofTiles]);

    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto', position: 'relative' }}>
            <h2 style={{ color: '#007a3d', borderBottom: '3px solid #007a3d', paddingBottom: '10px' }}>Test-Tool für Top-Kacheln</h2>
            
            {/* Info Overlay */}
            {showInfoOverlay && (
                <>
                    <div 
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 999
                        }}
                        onClick={() => setShowInfoOverlay(null)}
                    ></div>
                    <div style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                        maxWidth: '500px',
                        zIndex: 1000
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, color: '#007a3d' }}>
                                {showInfoOverlay === 'results' ? 'Max. Anzahl Resultate' : 'Themenvielfalt'}
                            </h3>
                            <i 
                                className="fas fa-times" 
                                style={{ cursor: 'pointer', fontSize: '20px', color: '#666' }}
                                onClick={() => setShowInfoOverlay(null)}
                            ></i>
                        </div>
                        <p style={{ lineHeight: '1.6', color: '#333' }}>
                            {showInfoOverlay === 'results' 
                                ? 'Bestimmt die maximale Anzahl der Kacheln, die angezeigt werden sollen. Der Wert kann zwischen 1 und 10 liegen. Dies begrenzt die Gesamtzahl der Top-Resultate für das gewählte Thema.'
                                : '1 = breite Abdeckung vieler Themen, 2+ = tiefere Abdeckung einzelner wichtiger Themen.'}
                        </p>
                    </div>
                </>
            )}
            
            <div style={{ 
                backgroundColor: '#f5f5f5', 
                padding: '20px', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginBottom: '20px'
            }}>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#333' }}>
                        Themen-URL:
                    </label>
                    <input 
                        type="text" 
                        id="topicUrl" 
                        value={baseUrl}
                        style={{ 
                            width: '100%', 
                            padding: '8px 12px',
                            border: '2px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px',
                            boxSizing: 'border-box'
                        }} 
                        onChange={(e) => {
                            let url = e.target.value;
                            if (url.endsWith('.html')) {
                                url = url.substring(0, url.length - 5);
                            }
                            setBaseUrl(url);
                        }}
                    />
                </div>

                <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold', marginBottom: '5px', color: '#333' }}>
                            <span>Max. Anzahl Resultate:</span>
                            <i 
                                className="fas fa-info-circle" 
                                style={{ cursor: 'pointer', color: '#007a3d', fontSize: '16px' }}
                                onClick={() => setShowInfoOverlay('results')}
                                title="Info"
                            ></i>
                        </label>
                        <input 
                            type="number" 
                            value={nofTiles}
                            style={{ 
                                width: '100%', 
                                padding: '8px 12px',
                                border: '2px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }} 
                            min={1} 
                            max={10}
                            onChange={(e) => setNofTiles(parseInt(e.target.value) || 1)}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold', marginBottom: '5px', color: '#333' }}>
                            <span>Themenvielfalt:</span>
                            <i 
                                className="fas fa-info-circle" 
                                style={{ cursor: 'pointer', color: '#007a3d', fontSize: '16px' }}
                                onClick={() => setShowInfoOverlay('cluster')}
                                title="Info"
                            ></i>
                        </label>
                        <input 
                            type="number" 
                            value={maxItemsPerCluster}
                            style={{ 
                                width: '100%', 
                                padding: '8px 12px',
                                border: '2px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }} 
                            min={1} 
                            max={3}
                            onChange={(e) => setMaxItemsPerCluster(parseInt(e.target.value) || 1)}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#333' }}>
                            Ansicht Resultate:
                        </label>
                        <div style={{ display: 'flex', gap: '15px', marginTop: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input 
                                    type="radio" 
                                    name="viewMode" 
                                    value="tile" 
                                    checked={viewMode === 'tile'}
                                    onChange={(e) => setViewMode('tile')}
                                    style={{ marginRight: '5px' }}
                                />
                                <span>Kachel</span>
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input 
                                    type="radio" 
                                    name="viewMode" 
                                    value="list" 
                                    checked={viewMode === 'list'}
                                    onChange={(e) => setViewMode('list')}
                                    style={{ marginRight: '5px' }}
                                />
                                <span>Liste</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            {
            baseUrl &&
                <>
                <h3 style={{ color: '#007a3d', marginBottom: '20px' }}>{baseUrl}</h3>
                
                {viewMode === 'list' ? (
                    <div style={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        { (topTiles || []).map((tile: any, index: number) => {
                            return (
                                <a 
                                    key={index} 
                                    href={tile.content_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{
                                        backgroundColor: 'white',
                                        border: '1px solid #e0e0e0',
                                        borderLeft: '4px solid #007a3d',
                                        borderRadius: '4px',
                                        padding: '20px 24px',
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        display: 'block',
                                        transition: 'all 0.2s ease',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,122,61,0.15)';
                                        e.currentTarget.style.borderLeftWidth = '6px';
                                        e.currentTarget.style.transform = 'translateX(2px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                                        e.currentTarget.style.borderLeftWidth = '4px';
                                        e.currentTarget.style.transform = 'translateX(0)';
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                                        <div style={{ 
                                            backgroundColor: '#007a3d', 
                                            color: 'white', 
                                            minWidth: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                            flexShrink: 0
                                        }}>
                                            {index + 1}
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <h3 style={{ 
                                                margin: '0 0 8px 0', 
                                                color: '#007a3d',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                lineHeight: '1.4'
                                            }}>
                                                {tile.title_ai_generated || tile.title}
                                            </h3>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                color: '#666',
                                                marginBottom: '8px',
                                                lineHeight: '1.5'
                                            }}>
                                                {tile.title_ai_generated && tile.title !== tile.title_ai_generated && (
                                                    <div style={{ marginBottom: '4px' }}>
                                                        <strong>Seitentitel:</strong> {tile.title}
                                                    </div>
                                                )}
                                            </div>
                                            <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center',
                                                gap: '16px',
                                                fontSize: '13px',
                                                color: '#888'
                                            }}>
                                                <span style={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                }}>
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                                                    </svg>
                                                    Popularität: {tile.popularity}
                                                </span>
                                                <span style={{ 
                                                    color: '#007a3d',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {tile.content_url.replace('https://www.sg.ch', 'sg.ch')}
                                                </span>
                                            </div>
                                        </div>
                                        <div style={{
                                            color: '#007a3d',
                                            fontSize: '20px',
                                            flexShrink: 0
                                        }}>
                                            →
                                        </div>
                                    </div>
                                </a>
                            );
                        })
                        }
                    </div>
                ) : (
                    <div style={{ 
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '20px'
                    }}>
                        { (topTiles || []).map((tile: any, index: number) => {
                            // Determine color scheme based on tile_style
                            const getTileColors = (tileStyle: string) => {
                                const style = (tileStyle || '').toLowerCase();
                                if (style.includes('green')) {
                                    return { bg: '#cce6d6', text: '#008334' };
                                } else if (style.includes('blue')) {
                                    return { bg: '#ccd4dc', text: '#193d61' };
                                } else if (style.includes('red')) {
                                    return { bg: '#ebccd6', text: '#990033' };
                                } else {
                                    return { bg: '#cce6d6', text: '#008334' }; // default green
                                }
                            };

                            const colors = getTileColors(tile.tile_style);
                            const hasImage = tile.tile_image && tile.tile_image.trim();
                            
                            console.log(tile.tile_image);
                            return (
                                <div 
                                    key={index} 
                                    style={{
                                        backgroundColor: '#fff',
                                        flex: '0 0 calc(25% - 15px)',
                                        minWidth: '280px',
                                        height: '270px',
                                        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)',
                                        transition: 'all ease-out 0.4s',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        margin: '0 0 25px 0'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 14px 0 rgba(0, 0, 0, 0.55)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px 0 rgba(0, 0, 0, 0.15)';
                                    }}
                                    onClick={() => window.open(tile.content_url, '_blank')}
                                >
                                    {/* Header Section with colored background */}
                                    <div style={{
                                        backgroundColor: colors.bg,
                                        height: '50%',
                                        padding: '25.2px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'flex-end',
                                        position: 'relative',
                                        backgroundImage: hasImage ? `url("https://www.sg.ch${tile.tile_image}")` : 'none',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center center'
                                    }}>
                                        {/* Icon - nur anzeigen wenn kein Bild vorhanden */}
                                        {tile.tile_icon && !hasImage && (
                                            <div style={{
                                                color: colors.text,
                                                fontSize: '45px',
                                                lineHeight: '1',
                                                fontWeight: 'normal',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className={tile.tile_icon}></i>
                                            </div>
                                        )}
                                    </div>

                                    {/* Content Section */}
                                    <div style={{
                                        padding: '25.2px',
                                        height: '50%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                    }}>
                                        {/* Main Topic in gray */}
                                        <div style={{
                                            fontSize: '14px',
                                            color: '#757575',
                                            lineHeight: '1.2em',
                                            marginBottom: '8px'
                                        }}>
                                            {tile.main_topic}
                                        </div>
                                        
                                        {/* Title at bottom */}
                                        <h4 style={{ 
                                            margin: '0',
                                            color: '#1b1b1b',
                                            fontSize: '18px',
                                            fontWeight: '600',
                                            lineHeight: '1.2em',
                                            maxHeight: '64px',
                                            overflow: 'hidden',
                                            WebkitFontSmoothing: 'antialiased',
                                            MozOsxFontSmoothing: 'grayscale',
                                            hyphens: 'auto',
                                            wordWrap: 'break-word'
                                        }}
                                        lang="de">
                                            {tile.title_ai_generated || tile.title}
                                        </h4>
                                    </div>
                                </div>
                            );
                        })
                        }
                    </div>
                )}
                </>
            }
        </div>
    )
}